import { DOCUMENT, inject } from '@angular/core';

type HotjarWindow = Window & {
  hj?: ((...args: unknown[]) => void) & { q?: unknown[] };
  _hjSettings?: { hjid: string; hjsv: number };
};

const HOTJAR_SCRIPT_ID = 'hotjar-script';

/**
 * Carrega o Hotjar (snippet oficial, sem biblioteca) quando há um ID configurado.
 * Precisa rodar num contexto de injeção (ex.: `provideAppInitializer`).
 */
export function loadHotjar(trackingCode: string | null): void {
  if (!trackingCode) {
    return;
  }

  const document = inject(DOCUMENT);
  const win = document.defaultView as HotjarWindow | null;
  if (!win || document.getElementById(HOTJAR_SCRIPT_ID)) {
    return;
  }

  if (!win.hj) {
    const queue: unknown[] = [];
    win.hj = Object.assign((...args: unknown[]) => queue.push(args), { q: queue });
  }
  win._hjSettings = { hjid: trackingCode, hjsv: 6 };

  const script = document.createElement('script');
  script.id = HOTJAR_SCRIPT_ID;
  script.async = true;
  script.src = `https://static.hotjar.com/c/hotjar-${trackingCode}.js?sv=6`;
  document.head.appendChild(script);
}
